import * as React from 'react';

export interface OnboardingInfo {
  isRenderOnboardingTicketView: boolean,
  onboarding: Array<Record<string, any>>;
}

export const OnboardingInfoContext = React.createContext<OnboardingInfo>(null);
